import type {
  APIDashboardFilterExpression,
  DashboardFilterValues,
} from '@ardoq/api-types';
import { isEmpty, omit } from 'lodash';

type WithUpdatedFilterValueArgs = {
  globalFilterValues: DashboardFilterValues;
  parameterId: string;
  values: APIDashboardFilterExpression[] | null;
};

export const withUpdatedFilterValue = ({
  globalFilterValues,
  parameterId,
  values,
}: WithUpdatedFilterValueArgs): DashboardFilterValues =>
  !values || isEmpty(values)
    ? omit(globalFilterValues, parameterId)
    : { ...globalFilterValues, [parameterId]: values };
